import script from "./goRinSyo0023.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0023.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0023.vue?vue&type=style&index=0&id=6ae00aca&lang=scss"

const __exports__ = script;

export default __exports__